import { useDispatch } from 'react-redux';
import { updateFavourite } from '@noths/polaris-client-user-favourites';
import getConfig from 'next/config';

import { actions } from 'src/redux/productMediaCarousel/slice';
import type { AppThunkDispatch } from 'src/redux/store';
import type { NextConfig } from 'src/types/nextConfig';
import type { ProductMediaCarouselDispatchProps } from './ProductMediaCarousel';

export const useProductMediaCarouselActions = (): ProductMediaCarouselDispatchProps => {
  const dispatch = useDispatch<AppThunkDispatch>();
  const nextConfig = getConfig() as NextConfig;

  return {
    onFavouriteClick: (productCode) => dispatch(updateFavourite({ productCode, nextConfig })),
    onNextMedia: (payload) => dispatch(actions.nextMedia(payload)),
    onOpenModal: (payload) => dispatch(actions.openModal(payload)),
    onPrevMedia: (payload) => dispatch(actions.prevMedia(payload)),
    setCurrentMedia: (payload) => dispatch(actions.setCurrentMedia(payload)),
  };
};
